//@flow
import React from 'react';
import classnames from 'classnames';
import stylesheet from './TimeoutBar.scss';

import type { ToastType } from './Toast';

type TimeoutBarProps = {|
    className?: string,
    duration: number,
    inProgress: boolean,
    type: ToastType,
|};

export function TimeoutBar({ className, duration, inProgress, type }: TimeoutBarProps) {
    return (
        <div className={className}>
            <div
                className={classnames(stylesheet.bar, stylesheet[type])}
                style={{
                    transition: `width ${duration}ms linear`,
                    width: `${inProgress ? 0 : 100}%`,
                }}
            />
        </div>
    );
}
